import { render, staticRenderFns } from "./survey-step-1.scene.vue?vue&type=template&id=a56b009c"
import script from "./survey-step-1.scene.ts?vue&type=script&lang=ts&external"
export * from "./survey-step-1.scene.ts?vue&type=script&lang=ts&external"
import style0 from "./survey-step-1.scene.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRating } from 'vuetify/lib/components/VRating';
installComponents(component, {VRating})
